import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Game3Store from "../../stores/Game3Store";

@inject('Game3Store')
@observer
export default class Game3Step4 extends Component {

    render() {

        const player = Game3Store.getPlayerTurn();

        const tasksEl = player.tasks.map(
            (task, index) => <div className="question" key={index}>
                {task.statement.image &&
                <div className="question-image"
                     style={{backgroundImage: `url(images/${task.statement.image}.jpg)`}}/>
                }
                <div className="question-statement">
                    <label className="label-task-guideline">Task {index+1}</label>
                    <p className={index == 3 ? "p-task4" : "" }><strong>{task.name}</strong> <br/>{task.statement.statement}</p>
                </div>
            </div>
        );


        return (
            <div className="step-4">
                <h1>Guidelines</h1>
                <br/>
                <div className={"team-name " + player.team.color}>{player.name}</div>
                {tasksEl}
            </div>
        )
    }

};



// WEBPACK FOOTER //
// ./src/containers/Game3/Game3Step4.js